import { VStack } from '@src/components/Core';
import { Divider } from '@src/components/Divider';
import { Text } from '@src/components/Text';

export function DividerContent({ title }: { title?: string }) {
  if (!title) {
    return <Divider data-testid="entity-admin-drawer-divider" />;
  }

  return (
    <VStack w="100%" gap="spacing8" alignItems="flex-start" data-testid="entity-admin-drawer-divider" pb="spacing8">
      <Divider />
      <Text weight="fontWeightBold" color="colorTextImportant">
        {title}
      </Text>
    </VStack>
  );
}
